

var Delivery = function()
{

	/**
	 * [quote description]
	 * @return {[type]} [description]
	 */
	this.quote = function()
	{

		/**
		 * [getQuoteHandler description]
		 * @param  {[type]} e [description]
		 * @return {[type]}   [description]
		 */
		var getQuoteHandler = function(e)
		{
			e.preventDefault();
			var container = $( '[data-javascript="delivery-quote"]' );
			var postcode = $( '#postcode', container ).val();
			var countryID = $( '#country', container ).val();
			var x_csrf_token = $( '[name="_token"]', container ).val();
			var ajaxResult = $( '#ajax-result', container );
			$.ajax({
				url : '/delivery/ajax-quote/' + countryID + '/' + postcode + '/',
				type : 'POST',
				headers : {
			                	'X-CSRF-TOKEN' : x_csrf_token
			            },
			             success : function( response ){
			                	var ul = $( '<ul />' ).addClass( 'ui list' );
			                	response.forEach( function( delivery ){
			                		var item = $( '<li />' );
			                		item.html( delivery.delivery.display_name + ': ' + delivery.price.display_formatted );
			                		item.appendTo( ul );
			                	});
			                	ajaxResult.html('').append( ul );
			             },
			             error: function ( xhr, textstatus, errorThrown ) {
			                	var response = JSON.parse( xhr.responseText );
			                	var ul = $( '<ul />' ).addClass( 'ui error message' ).css( 'display', 'block' );
			                	var item = $( '<li />' ).text( response.calculate ).appendTo( ul );
			                	ajaxResult.html('').append( ul );
			            }
			});
		};

		/**
		 * [bindEvents description]
		 * @return {[type]} [description]
		 */
		var bindEvents = function()
		{
			$('#delivery-quote').unbind( 'click' ).bind( 'click', getQuoteHandler );
		};

		/**
		 * [description]
		 * @return {[type]} [description]
		 */
		return new function()
		{
			bindEvents();
		};
	};

};


jQuery(document).ready( function($){

	var delivery = new Delivery();

	if( $('[data-javascript="delivery-quote"]').length ) {
		delivery.quote();
	}

});